export default __webpack_public_path__ + "static/media/12.771e885e.jpg";